import { TabContent } from '@screens/landing-page-team/types';

export const tabsAndContents: TabContent[] = [
  {
    tab: 'Editores-chefe',
    description:
      'Os editores-chefes são responsáveis pela supervisão geral do conteúdo médico dentro de suas respectivas áreas. Eles garantem a qualidade científica, revisam materiais e lideram as diretrizes editoriais.',
    publishers: [
      {
        id: 1,
        name: 'Ronaldo Gismondi',
        role: 'Diretor médico',
        specialty: 'Cardiologista, PhD',
        image: 'lp-team-ronaldo-gismondi.webp',
      },
      {
        id: 2,
        name: 'Caroline Oliveira',
        role: 'Editora-chefe',
        specialty: 'Ginecologista e Obstetra, PhD',
        image: 'lp-team-caroline-oliveira.webp',
      },
      {
        id: 3,
        name: 'Dayanna Quintanilha',
        role: 'Especialista',
        specialty: 'Clínica Médica, MSc',
        image: 'lp-team-dayanna-quintanilha.webp',
      },
      {
        id: 4,
        name: 'Dolores Henrique',
        role: 'Editora-chefe',
        specialty: 'Pediatra',
        image: 'lp-team-dolores-henriques.webp',
      },
      {
        id: 5,
        name: 'Geisa Lucho',
        role: 'Especialista',
        specialty: 'Farmacêutica',
        image: 'lp-team-geisa-lucho.webp',
      },
      {
        id: 6,
        name: 'Gustavo Balbi',
        role: 'Editor-chefe',
        specialty: 'Reumatologista, Clínica Médica',
        image: 'lp-team-gustavo-balbi.webp',
      },
      {
        id: 7,
        name: 'Renato Bergallo',
        role: 'Editor-chefe',
        specialty: 'Médico de Família, MSc',
        image: 'lp-team-renato-bergallo.webp',
      },
    ],
  },
  {
    tab: 'Editores associados',
    description:
      'Os editores associados auxiliam os editores-chefes na revisão e curadoria do conteúdo científico. Eles contribuem para a análise de artigos, atualização de informações médicas e suporte editorial em suas especialidades.',
    publishers: [
      {
        id: 8,
        name: 'Alléxya Affonso',
        specialty: 'Oftalmologia',
      },
      {
        id: 9,
        name: 'Ênio Luís Damaso',
        specialty: 'Ginecologia e obstetrícia',
      },
      {
        id: 10,
        name: 'Ester Ribeiro',
        specialty: 'Nefrologia',
      },
      {
        id: 11,
        name: 'Felipe Victer',
        specialty: 'Cirurgia Geral',
      },
      {
        id: 12,
        name: 'Gabriela Balbi',
        specialty: 'Pediatria',
      },
      {
        id: 13,
        name: 'Giovanni Guedes',
        specialty: 'Ortopedia',
      },
      {
        id: 14,
        name: 'Isabel Melo Mendes',
        specialty: 'Infectologia',
      },
      {
        id: 15,
        name: 'Isabela Kirnew Abud',
        specialty: 'Cardiologia',
      },
      {
        id: 16,
        name: 'Juliane Braziliano',
        specialty: 'Endocrinologia',
      },
      {
        id: 17,
        name: 'Leandro Lima da Silva',
        specialty: 'Clínica Médica',
      },
      {
        id: 18,
        name: 'Lethicia David Prado',
        specialty: 'Oncologia',
      },
      {
        id: 19,
        name: 'Mariana Santino',
        specialty: 'Dermatologia',
      },
      {
        id: 20,
        name: 'Marselle Codeço',
        specialty: 'Dermatologia',
      },
      {
        id: 21,
        name: 'Pedro Serrão Morales',
        specialty: 'Medicina Laboratorial',
      },
      {
        id: 22,
        name: 'Raíssa Perlingeiro',
        specialty: 'Infectologia',
      },
      {
        id: 23,
        name: 'Renata da Cruz',
        specialty: 'Pediatria',
      },
      {
        id: 24,
        name: 'Roberta Esteves',
        specialty: 'Pediatria',
      },
      {
        id: 25,
        name: 'Tayne de Miranda',
        specialty: 'Psiquiatria',
      },
      {
        id: 26,
        name: 'Vanessa Santos',
        specialty: 'Cirurgia Pediátrica',
      },
      {
        id: 27,
        name: 'Yuri de Albuquerque',
        specialty: 'Medicina Intensiva',
      },
    ],
  },
  {
    tab: 'Editores-assistentes',
    description:
      'Os editores-assistentes colaboram na produção e revisão inicial dos conteúdos médicos. Eles auxiliam na checagem de informações, atualização de dados e apoio técnico ao corpo editorial.',
    publishers: [
      {
        id: 28,
        name: 'Amanda Gabriela Gomes',
        specialty: 'Medicina',
      },
      {
        id: 29,
        name: 'Giovane Sampaio Rossi',
        specialty: 'Medicina',
      },
      {
        id: 30,
        name: 'Guilherme Schittine Lomba',
        specialty: 'Medicina',
      },
      {
        id: 31,
        name: 'Johnatan da Conceição',
        specialty: 'Medicina',
      },
      {
        id: 32,
        name: 'Juliana Karpinski',
        specialty: 'Medicina',
      },
      {
        id: 33,
        name: 'Raquel Ferreira',
        specialty: 'Analista de Farmácia',
      },
      {
        id: 34,
        name: 'Thalita Lima',
        specialty: 'Analista de Farmácia',
      },
    ],
  },
];
